<div class="bridges-help">
  <ion-text color="primary"><h2>{{ 'BRIDGES.help_dialog.title' | translate }}</h2></ion-text>
  <ion-text class="intro" [innerHTML]="'BRIDGES.help_dialog.text' | translate"></ion-text>

  <div class="help-section">
    <ion-text color="primary"><h3>{{ 'BRIDGES.help_dialog.mechanics.play.title' | translate }}</h3></ion-text>
    <ion-text *ngIf="!isMobile" [innerHTML]="'BRIDGES.help_dialog.mechanics.play.text.desktop' | translate"></ion-text>
    <ion-text *ngIf="isMobile" [innerHTML]="'BRIDGES.help_dialog.mechanics.play.text.mobile' | translate"></ion-text>
  </div>

  <div class="help-section">
    <ion-text color="primary"><h3>{{ 'BRIDGES.help_dialog.mechanics.delete.title' | translate }}</h3></ion-text>
    <ion-text *ngIf="!isMobile" [innerHTML]="'BRIDGES.help_dialog.mechanics.delete.text.desktop' | translate"></ion-text>
    <ion-text *ngIf="isMobile" [innerHTML]="'BRIDGES.help_dialog.mechanics.delete.text.mobile' | translate"></ion-text>
  </div>

  <!-- Always shown, whatever the settings say: each paragraph names the setting
       that produces it, so the player can decide what to switch on from here. -->
  <div class="help-section">
    <ion-text color="primary"><h3>{{ 'BRIDGES.help_dialog.mechanics.markings.title' | translate }}</h3></ion-text>
    <ion-text [innerHTML]="'BRIDGES.help_dialog.mechanics.markings.text.rules' | translate"></ion-text>
    <ion-text [innerHTML]="'BRIDGES.help_dialog.mechanics.markings.text.solution' | translate"></ion-text>
  </div>
</div>
